import { IApplicationState } from '../../types/redux';
import { selectLkType } from '../lkType';

export const selectUserIsAgent = (state: IApplicationState) => {
  return selectLkType(state) === 'specialist';
};
